import { render, staticRenderFns } from "./form.vue?vue&type=template&id=f99497da&scoped=true&lang=pug&"
import script from "./form.vue?vue&type=script&setup=true&lang=js&"
export * from "./form.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=f99497da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99497da",
  null
  
)

export default component.exports